import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/answer/rule/AnswerRuleResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/answer/v1/configs`;
	}
	list(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/rules`, t));
	}
	get(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/rules/${t}`));
	}
	delete(e, t) {
		return this.api.delete(this.buildPath(`${n.baseUrl}/${e}/rules/${t}`));
	}
	edit(e, t, r) {
		return this.api.put(`${n.baseUrl}/${e}/rules/${t}`, r);
	}
	create(e, t) {
		return this.api.post(`${n.baseUrl}/${e}/rules`, t);
	}
};
//#endregion
export { n as AnswerRuleResource };

//# sourceMappingURL=AnswerRuleResource.js.map